interface Props {
    label: string;
    isRequired?: boolean;
    className?: string;
}

export const Label = ({ label, isRequired, className }: Props) => {
    return (
        <label className={className}>
            {label}
            {isRequired ? <span className="input-style_is_req">*</span> : ''}
        </label>
    );
};
